// extracted by mini-css-extract-plugin
export var footer = "_mb-5";
export var fulfillmentInput = "_mb-0";
export var shipDateInput = "_mb-1";
export var shipmentModal = "_mb-2";
export var shipmentModalContent = "_mb-3";
export var tableContainer = "_mb-4";